export default __webpack_public_path__ + "media/images/ic-cost-2-51e78a235e275d9dc6f337e6bb8fe31c.png";